import React, { Fragment, useEffect, useState } from "react";
import "./Applications.css";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import Model from "../../components/model/Model";
import { getPatientById } from "../../api/patient";
import { decryptPatientData } from "../../utils/common";
import { useDispatch, useSelector } from "react-redux";
import { failed } from "../../utils/Tostify";
import { decryptData } from "../../utils/helper";
import AddApplications from "../patient/addpatient/AddApplications";
import Loader from "../../components/Loader/Loader";

function Applications() {
    const [openModel, setOpenModel] = useState(false);
    let token = useSelector((state) => state.userReducer.token);
    let user = useSelector(state => state.userReducer.user);
    const dispatch  = useDispatch();
    const [isLoading, setIsLoading] = useState(false);
    const [application, setApplication] = useState();
    const patient = useSelector((state) => state?.userReducer?.user);
    const [statusFilter, setStatusFilter] = useState('All');

    const [activeTab, setActiveTab] = useState('1');
    const toggleTab = (tab) => {
        if (activeTab !== tab) setActiveTab(tab);
    };

    const handleStatusChange = (status) => {
        setStatusFilter(status); // Set the filter status
    };

    const getPatient = async () => {
        let res;
        try {
            setIsLoading(true);
            res = await getPatientById({ dispatch, token, id: patient?._id, userId : user?._id });
            const responseData = decryptData(res.data);
            const decryptedPatient =await decryptPatientData(responseData);
            if (res?.status === "SUCCESS") {
                setApplication(decryptedPatient);
                setIsLoading(false);
            }
        } catch (error) {
            failed(res?.message);
            setIsLoading(false);
        }
    };

    useEffect(() => {
        if(patient?._id){
            getPatient();
        }
    }, [patient?._id]);

    return (
        <Fragment>
            {isLoading ? <Loader /> : null}
            {openModel ? <Model modal={openModel} handleClose={() => setOpenModel(false)} /> : null}
            <div className="applications-container application_user">
                <h2 className="home-title">Applications</h2>
                <div>
                    <Nav tabs className="profile_intab horizontal-scroll d-flex">
                        <NavItem>
                            <NavLink
                                className={activeTab === '1' ? 'active' : ''}
                                onClick={() => {toggleTab('1');handleStatusChange('All');}}
                            >
                                All Applications
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '2' ? 'active' : ''}
                                onClick={() => {toggleTab('2');handleStatusChange('InProcess');}}
                            >
                                Open Applications
                            </NavLink>
                        </NavItem>
                        <NavItem>
                            <NavLink
                                className={activeTab === '3' ? 'active' : ''}
                                onClick={() => {toggleTab('3');handleStatusChange('Approved');}}
                            >
                                Closed Applications
                            </NavLink>
                        </NavItem>
                    </Nav>
                    <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                            <AddApplications getPatient={()=>getPatient()} patientDeatils={application} statusFilter={statusFilter}/>
                        </TabPane>
                        <TabPane tabId="2">
                            <AddApplications getPatient={()=>getPatient()} patientDeatils={application} statusFilter={statusFilter}/>
                        </TabPane>
                        <TabPane tabId="3">
                        <AddApplications getPatient={()=>getPatient()} patientDeatils={application} statusFilter={statusFilter}/>
                        </TabPane>
                    </TabContent>
                </div>
            </div>
        </Fragment>
    );
}

export default Applications;
